import { AnalyticsProvider, GoogleTagManager } from "@lonelyplanet/dotcom-analytics";
import * as React from "react";
export function AppProviders(_a) {
    var children = _a.children;
    return (
    // TODO: remove <AnalyticsProvider> upon completion of transition to lp-analytics
    React.createElement(AnalyticsProvider, { trackers: [GoogleTagManager] }, children));
}



//////////////////
// WEBPACK FOOTER
// ./app/shared/appProviders.tsx
// module id = y78e
// module chunks = 2